import axios from "axios";
import axiosInstance from "../utils/axios-instance";
import { signInWithCustomToken } from "firebase/auth";
import { auth } from "../firebase";

export const loginUser = async (email: string, password: string) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/cms/login`,
    {
      email,
      password,
    },
  );

  const { data, message } = response.data;
  const { token: customToken, currentUser } = data;

  if (!customToken) {
    alert(message);
    return;
  }

  const userCredential = await signInWithCustomToken(auth, customToken);
  const idToken = await userCredential.user?.getIdToken();

  return { idToken, currentUser };
};

export const listUsers = async () => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_BASE_URL}/cms/list-users`,
  );
  return response.data.data;
};

export const createUser = async (data: object) => {
  const response = await axiosInstance.post(
    `${process.env.REACT_APP_API_BASE_URL}/cms/create-user`,
    data,
  );
  return response.data.message;
};

export const deleteUser = async (id: string, deletedBy: string) => {
  const response = await axiosInstance.patch(
    `${process.env.REACT_APP_API_BASE_URL}/cms/user/${id}`,
    { deletedBy },
  );
  return response.data.message;
};

export const viewUser = async (id: string) => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_BASE_URL}/cms/user/${id}`,
  );

  return response.data;
};

export const updateUser = async (id: string, data: object) => {
  const response = await axiosInstance.put(
    `${process.env.REACT_APP_API_BASE_URL}/cms/user/${id}`,
    data,
  );
  return response.data.message;
};

export const logoutUser = async (data: object) => {
  const response = await axiosInstance.post(
    `${process.env.REACT_APP_API_BASE_URL}/cms/logout`,
    data,
  );
  return response.data.message;
};

export const verifyPassword = async (data: {
  userId: string;
  password: string;
}) => {
  const response = await axiosInstance.post(
    `${process.env.REACT_APP_API_BASE_URL}/cms/verify-password`,
    data,
  );
  return response.data;
};

export const changePassword = async (data: {
  userId: string;
  password: string;
}) => {
  const response = await axiosInstance.post(
    `${process.env.REACT_APP_API_BASE_URL}/cms/change-password`,
    data,
  );
  return response.data.message;
};
